import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Currency, defaultCurrency, Icons} from '../../../../global';
import { InputAbstract } from '../base/input.abstract';
import { MatFormField, MatLabel, MatPrefix, MatSuffix, MatHint, MatError } from '@angular/material/form-field';
import { NgIf } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { SvgIconComponent } from '../../svg-icon/svg-icon.component';
import { MatInput } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective } from 'ngx-mask';
import { AutofocusDirective } from '../../../directives/autofocus.directive';
import { MatRipple } from '@angular/material/core';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'slm-amount-input',
    templateUrl: './amount-input.component.html',
    styles: [`
    :host {
      flex-direction: row;
      box-sizing: border-box;
      display: flex;
    }
  `],
    imports: [MatFormField, NgIf, MatLabel, TranslateDirective, MatPrefix, SvgIconComponent, MatInput, FormsModule, NgxMaskDirective, ReactiveFormsModule, AutofocusDirective, MatSuffix, MatRipple, MatTooltip, MatHint, MatError, TranslatePipe]
})
export class AmountInputComponent extends InputAbstract {
  @Input() public autoFocus = false;
  @Input() public buttonIcon = true;
  @Input() public prefixLabel = '';
  @Input() public allowNegativeNumber = true;
  @Input() public prefixIcon: Icons | string = null;
  @Input() public enterEnabled = false;
  public decimals = 'separator.0';
  private hasDecimal = false;

  @Input('decimals') public set setDecimals(decimals: number) {
    this.hasDecimal = true;
    this.decimals = `separator.${decimals ?? 0}`;
  }

  @Input('currency') public set setCurrency(currency: Currency) {
    if (!this.hasDecimal) {
      this.decimals = `separator.${currency?.precision ?? defaultCurrency.precision}`;
    }
    this.suffixLabel = currency?.prefix ?? '';
  }

  @Input() public suffixIcon: Icons = null;
  @Input() public suffixLabel = '';
  @Input() public suffixIconLabel = '';
  @Output() public commaPressed = new EventEmitter<boolean>();

  public clear(): void {
    if (this.control) {
      this.control.setValue('');
    }
    this.onClick('clear');
  }

  public setComma(event) {
    event.target.value = `${event.target.value}.`;
    this.commaPressed.emit(true);
  }
}
